import DarkButton from "components/actions/DarkButton";
import GrayButton from "components/actions/GrayButton";
import Dialog from "components/dialog";

const AttendanceConfirmation = ({userService, onConfirm, onCancel}) => {
    return (
        <Dialog isOpen={true} onClose={onCancel}>
            <h2 className="font-bold text-xl">Please confirm attendance</h2>
            <p className="text-sm font-medium my-6">
                <span>Please confirm you want to attend to {userService.service.name} taking place on</span>
                &nbsp;
                <span className="font-bold">
                    {new Date('2000-01-01 ' + userService.service.startAt).toLocaleTimeString([], {hour: "numeric", minute: "numeric"})}&nbsp;-&nbsp;
                    {new Date('2000-01-01 ' + userService.service.endAt).toLocaleTimeString([], {hour: "numeric", minute: "numeric"})}
                    &nbsp;@{userService.service.address}
                </span>
            </p>

            <div className="flex flex-col lg:flex-row gap-5">
                <DarkButton onClick={onConfirm}>Confirm</DarkButton>
                <GrayButton onClick={onCancel}>Cancel</GrayButton>
            </div>
        </Dialog>
    )
}

export default AttendanceConfirmation;